angular
	.module 'App.Repository'

.factory 'BillingInvoiceRepository', ['BaseRepository', (BaseRepository) ->
	class BillingInvoiceRepository extends BaseRepository
		@resource = '/billing_invoices'
		@isRestricted = true

	return new BillingInvoiceRepository
]
